import {Component, HostListener, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID,} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {TranslationsService} from "../../_services/translations/translations.service";
import {Router} from "@angular/router";
import {MenuMobileService} from "../../main/menu/menu-mobile.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.scss'],
    standalone: false
})
export class MenuBarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() customRouterLink: string[];
  @Input() menuLength: number = 0;
  isMainMenu: boolean
  isChefMenu: boolean;
  isSeasonMenu: boolean
  language: string;
  sub: Subscription;

  constructor(private translationsService: TranslationsService,
              private menuMobileHiddenService: MenuMobileService,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId: object) {
  }

  ngOnInit(): void {
    this.translationsService.getLanguage().subscribe(value => {
      this.language = value;
    })
  }

  ngOnChanges() {
    this.onResize();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  @HostListener('window:resize')
  async onResize() {
    // Guard against SSR: ngOnChanges() (and this @HostListener) reference window/location,
    // which are undefined in Node. Without this, the 4 menu pages binding [menuLength]
    // throw "window is not defined" during SSR render (degraded-SSR).
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const windowWidth = window.innerWidth;
    this.sub = this.menuMobileHiddenService.hiddenMobileMenu.subscribe(hidden => {
      if (windowWidth > 1220 || hidden) {
        this.checkPath();
      }
    })
  }

  private checkPath() {
    const pathname = location.pathname.split('/').pop();
    console.log(pathname);
    if (pathname == 'wybor_konesera') {
      this.isChefMenu = true;
    }
    if (pathname === 'menu') {
      this.isMainMenu = true
      this.isSeasonMenu = false
    } else if (pathname === 'season-menu') {
      this.isMainMenu = false
      this.isSeasonMenu = true
    } else {
      this.isMainMenu = false
      this.isSeasonMenu = false
    }
  }

  changeLanguage(language: string) {
    this.translationsService.setLanguage(language)
  }

  navigateTo(menu:string) {
    this.menuMobileHiddenService.nextHiddenMobileMenu(true);
    this.router.navigate([menu]).then(() => {
      setTimeout(() => {
        const element = document.getElementById('menu-mobile-0');
        if (element) {
          element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }, 100)
    })
  }
}
